import { render, staticRenderFns } from "./EditMeal.vue?vue&type=template&id=0487ab7b"
import script from "./EditMeal.vue?vue&type=script&lang=js"
export * from "./EditMeal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports